module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('com-title', {
    attrs: {
      "title": "合作伙伴",
      "subtitle": "部分合作伙伴，排名不分先后"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "content columns is-mobile"
  }, _vm._l((_vm.partners), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "column is-one-fifth-tablet is-half-mobile"
    }, [_c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    })])])
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-555f4c28","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/training/com-partner.vue
// module id = 452
// module chunks = 1